import { PureComponent } from 'react';

import Avatar from '@atlaskit/avatar';
import { CompareIcon } from '@atlassian/bitkit-icon';

import { Repository } from 'src/components/types';

import * as styles from './details-list.style';

type ForkListItemProps = {
  item: Repository;
};

export default class ForkListItem extends PureComponent<ForkListItemProps> {
  render() {
    const { item: fork } = this.props;

    const compareBranchLink = fork.parent
      ? `/${fork.full_name}/branches/compare/${fork.parent.full_name}..`
      : null;

    return (
      <styles.ListItem>
        <styles.ListItemAvatar>
          <Avatar
            href={fork.links.html.href}
            name={fork.full_name}
            src={fork.links.avatar.href}
            size="small"
          />
        </styles.ListItemAvatar>
        <styles.ListItemLink href={fork.links.html.href}>
          {fork.full_name}
        </styles.ListItemLink>
        {compareBranchLink && (
          <styles.ListItemIcon href={compareBranchLink}>
            <CompareIcon label="Compare Branches" />
          </styles.ListItemIcon>
        )}
      </styles.ListItem>
    );
  }
}
